module.exports = __webpack_public_path__ + "02_glasses_red.917a41c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer4/02_glasses_red.png
// module id = fwX8
// module chunks = 0